// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"410":"31d6cfe0","474":"0e5c9116"}[chunkId] + ".chunk.css";
};